// extracted by mini-css-extract-plugin
export default {"tabsHeaderContainer":"S0IkQh","tabsContainer":"fLUT0t","tabs":"gaCUP4","icon":"bm0sMl","indicator":"SfzH16","description":"cKfK9i"};